// extracted by mini-css-extract-plugin
module.exports = {"page":"_5D1LwsTm","main":"_5D3Z6Mp8","form":"_5D2_BhJ2","email":"_5D-28ti7","description":"_5D2FNLzn","description--has-margin":"_5D1rJFso","link":"_5Dy99S_K","submit":"_5D3Nlb5m"};